import React from 'react';
import styles from './styles.scss';

var Spinner = function Spinner(_ref) {
  var color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/React.createElement("span", {
    className: styles.spinner
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.graphic, " ").concat(color),
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px")
    }
  }));
};

Spinner.defaultProps = {
  color: 'default',
  size: 20
};
export default Spinner;